 <div class="importantMessageContainer">
    <div class="messageHeading">{{'MessageCenter.important.heading' | translate}}</div>
    <div class="additionalResource">
        <ul>
            <li class="additionalResourceItem" *ngFor="let item of importantMsgs"><a href="javascript:void(0)" (click)="clickEvent(item.url, token, $event)" [innerHTML]="item.title"></a></li>
        </ul>
    </div>
    <div class="disclaimer">{{'MessageCenter.important.disclaimer' | translate}}</div>
</div>